import { render, staticRenderFns } from "./wifiMall.vue?vue&type=template&id=c4b3de4c&scoped=true"
import script from "./wifiMall.vue?vue&type=script&lang=js"
export * from "./wifiMall.vue?vue&type=script&lang=js"
import style0 from "./wifiMall.vue?vue&type=style&index=0&id=c4b3de4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b3de4c",
  null
  
)

export default component.exports